import { SyncEventType } from '../../enums/syncEventType';
import { RealtimeEvent } from './realtimeEvent';

export class EventSprintcardClosed implements RealtimeEvent {

  public readonly type = SyncEventType.SPRINTCARD_CLOSED;
  public sprintId: number;

  constructor(sprintId: number) {
    this.sprintId = sprintId;
  }

  getPayload(): object {
    const payload = {
      'sprintId': this.sprintId
    };
    return payload;
  }

  static fromPayload(payload: any): EventSprintcardClosed {
    return new EventSprintcardClosed(
      payload['sprintId']
    );
  }

}

